module.exports = __webpack_public_path__ + "img/EY__demo-placeholder.757bbfdd.png";